export default "__VITE_PUBLIC_ASSET__36ac6b1c__"